const COMMENTS = [
  {
    avatar: 'H',
    name: '电影控阿杰',
    time: '2小时前',
    content: '花生影院的电影大全真的太全了！我之前在别的平台找了好久的老电影这里都有，而且高清画质真的完全不带缓冲的，体验拉满。电影排行榜也很有参考价值，帮我发现了好几部冷门好片。',
    movie: '在看《星际穿越2》',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    avatar: '小',
    name: '小透明的影单',
    time: '5小时前',
    content: '用了花生影院快半年了，不得不说更新速度是真的快。院线刚下映的电影，这里很快就能看到高清资源。而且没有乱七八糟的弹窗广告，观影体验很纯粹。',
    movie: '刚看完《春风沉醉》',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
  {
    avatar: '周',
    name: '周末观影指南',
    time: '昨天',
    content: '推荐花生影院的「精选专题」分类！按类型整理得特别清晰，悬疑片专区是我最爱，每部都有简短的介绍帮你判断适不适合自己。省去了大量选题时间。',
    movie: '在刷悬疑片清单',
    bg: 'bg-secondary-200',
    text: 'text-secondary-800',
  },
  {
    avatar: '大',
    name: '大娱乐家KK',
    time: '昨天',
    content: '作为资深影迷，最在意的就是画质和字幕质量。花生影院在这两方面做得非常到位，高清片源搭配精准中文字幕，观影完全不费力。排行榜功能也很有用，能看到大家都在看什么。',
    movie: '推荐了《流浪地球4》',
    bg: 'bg-primary-100',
    text: 'text-primary-700',
  },
  {
    avatar: '深',
    name: '深夜不关机',
    time: '2天前',
    content: '手机端体验也超级棒！通勤路上打开就能看，加载速度很快，在地铁上也不卡顿。缓存功能也很贴心，提前下载好回家路上慢慢看，省流量又流畅。',
    movie: '缓存了《哪吒3》',
    bg: 'bg-accent-100',
    text: 'text-accent-700',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            观影评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自真实影迷的使用反馈，听听大家怎么评价花生影院
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.map((comment, i) => (
            <div
              key={i}
              className={`p-5 md:p-6 rounded-xl bg-background-50 border border-secondary-100/60 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className={`w-10 h-10 rounded-full ${comment.bg} ${comment.text} flex items-center justify-center font-medium text-sm flex-shrink-0`}
                >
                  {comment.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-900">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
                <span
                  className={`text-xs px-2 py-0.5 rounded-full ${comment.bg} ${comment.text} whitespace-nowrap`}
                >
                  {comment.movie}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}